import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c48059c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c48059c')) {
      api.createRecord('5c48059c', component.options)
    } else {
      api.reload('5c48059c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c48059c&", function () {
      api.rerender('5c48059c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/feeInfo/index.vue"
export default component.exports